import React from "react";

import { CONTACT_DETAILS } from "../../data/content";

//Yellow Instagram & blue Facebook tiles (home & About pages)
const SocialTiles = ({ className = "" }) => (
  <div className={`social-tiles ${className}`}>
    <a
      href={CONTACT_DETAILS.INSTAGRAM_LINK}
      className={"social-tile is-instagram"}
      target={"_blank"}
      rel={"noopener noreferrer"}
      aria-label={"Salgado's on Instagram"}
    >
      <img
        src={"/images/icons/instagram.svg"}
        alt={""}
        width={110}
        height={110}
      />
    </a>
    <a
      href={CONTACT_DETAILS.FACEBOOK_LINK}
      className={"social-tile is-facebook"}
      target={"_blank"}
      rel={"noopener noreferrer"}
      aria-label={"Salgado's on Facebook"}
    >
      <img
        src={"/images/icons/facebook.svg"}
        alt={""}
        width={110}
        height={110}
      />
    </a>
  </div>
);

export default SocialTiles;
